// @ts-nocheck
// ====== Cestino clienti (soft-delete) ======
// Mostra in vista Sicurezza la lista dei clienti spostati nel cestino e
// permette di ripristinarli o eliminarli definitivamente. Auto-purge a
// 30 giorni gestito da pg_cron (vedi migrazione 20260527120000).

async function renderTrash() {
  if (!isAdmin()) return;
  const tbody = document.getElementById('tbodyTrash');
  const countEl = document.getElementById('trashCount');
  if (!tbody) return;
  tbody.innerHTML =
    '<tr><td colspan="6" style="text-align:center;padding:20px;color:var(--text-muted)">Caricamento…</td></tr>';
  let items = [];
  try {
    items = await api.listDeletedClients();
  } catch (e) {
    console.error(e);
    tbody.innerHTML = `<tr><td colspan="6" style="text-align:center;padding:20px;color:var(--danger)">Errore caricamento cestino: ${escapeHtml(e.message || String(e))}</td></tr>`;
    return;
  }
  if (countEl) {
    countEl.textContent = items.length
      ? `${items.length} cliente${items.length === 1 ? '' : 'i'} nel cestino`
      : 'Cestino vuoto';
  }
  if (!items.length) {
    tbody.innerHTML =
      '<tr><td colspan="6" style="text-align:center;padding:24px;color:var(--text-muted)">Cestino vuoto — nessun cliente da ripristinare.</td></tr>';
    return;
  }
  const now = Date.now();
  tbody.innerHTML = items
    .map((it) => {
      const delAt = it.deletedAt ? new Date(it.deletedAt) : null;
      const purgeAt = delAt ? new Date(+delAt + 30 * 86400000) : null;
      const daysLeft = purgeAt ? Math.ceil((+purgeAt - now) / 86400000) : null;
      const purgeLabel =
        daysLeft == null
          ? '—'
          : daysLeft <= 0
            ? '<span class="dl-danger deadline-pill">In purge</span>'
            : daysLeft <= 7
              ? `<span class="dl-warn deadline-pill">Tra ${daysLeft}gg</span>`
              : `<span class="dl-ok deadline-pill">Tra ${daysLeft}gg</span>`;
      const peri =
        (it.perimetri || [])
          .map((p) => `<span class="perimeter-pill ${perimetroClass(p)}">${escapeHtml(p)}</span>`)
          .join(' ') || '<span class="muted">—</span>';
      return `
        <tr data-tid="${escapeHtml(it.id)}">
          <td data-label="Cliente"><strong>${escapeHtml(it.nome)}</strong></td>
          <td data-label="CPL">${escapeHtml(it.cpl || '—')}</td>
          <td data-label="Perimetri">${peri}</td>
          <td data-label="Eliminato" title="${escapeHtml(delAt ? delAt.toISOString() : '')}">${escapeHtml(delAt ? fmtDateTime(delAt.toISOString()) : '—')}</td>
          <td data-label="Auto-purge">${purgeLabel}</td>
          <td class="user-actions">
            <button class="btn btn-sm btn-primary" data-trash-restore="${escapeHtml(it.id)}">Ripristina</button>
            <button class="btn btn-sm btn-danger"  data-trash-hard="${escapeHtml(it.id)}" data-name="${escapeHtml(it.nome)}">Elimina definitivamente</button>
          </td>
        </tr>`;
    })
    .join('');

  tbody.querySelectorAll('[data-trash-restore]').forEach((btn) => {
    btn.addEventListener('click', () => restoreTrashed(btn.dataset.trashRestore));
  });
  tbody.querySelectorAll('[data-trash-hard]').forEach((btn) => {
    btn.addEventListener('click', () => hardDeleteTrashed(btn.dataset.trashHard, btn.dataset.name));
  });
}

async function restoreTrashed(id) {
  if (!isAdmin()) return;
  try {
    await api.restoreClient(id);
    logAudit({
      action: 'update',
      entity: 'Cliente',
      target: id,
      details: 'Cliente ripristinato dal cestino'
    });
    toast('Cliente ripristinato');
    if (typeof loadStateFromSupabase === 'function') await loadStateFromSupabase();
    if (typeof renderAll === 'function') renderAll();
    renderTrash();
  } catch (e) {
    console.error(e);
    toast('Errore ripristino: ' + (e.message || e));
  }
}

async function hardDeleteTrashed(id, name) {
  if (!isAdmin()) return;
  const ok = await confirmAction({
    level: 'danger',
    title: 'Eliminazione definitiva',
    message: `Stai per eliminare definitivamente "${name || id}" dal cestino. L'operazione è irreversibile.`,
    details: [
      'Tutti i dati collegati (accessi, contratti, scadenze, ecc.) saranno persi',
      'Lo storico delle modifiche resta visibile',
      'Per recuperare i dati dovrai usare un backup precedente'
    ],
    warning: 'Operazione irreversibile.',
    confirmText: 'Elimina definitivamente',
    requireType: 'ELIMINA DEFINITIVAMENTE'
  });
  if (!ok) return;
  try {
    await api.hardDeleteClient(id);
    logAudit({
      action: 'delete',
      entity: 'Cliente',
      target: name || id,
      details: 'Cliente eliminato definitivamente dal cestino'
    });
    toast('Cliente eliminato definitivamente');
    renderTrash();
  } catch (e) {
    console.error(e);
    toast('Errore eliminazione: ' + (e.message || e));
  }
}

Object.assign(globalThis, { renderTrash, restoreTrashed, hardDeleteTrashed });
export {};
